(function () {
  if (window.StenInit && window.StenInit['sten-sub-collections-v2']) return;
  window.StenInit = window.StenInit || {};
  window.StenInit['sten-sub-collections-v2'] = true;

  function initSection(root) {
    if (root.dataset.stenInitialized) return;
    root.dataset.stenInitialized = 'true';

  const scrollContainer = root.querySelector('.sten-subcollections-scroll');
  const cards = root.querySelectorAll('.sten-subcollection-card');
  const leftArrow = root.querySelector('.sten-nav-arrow-left');
  const rightArrow = root.querySelector('.sten-nav-arrow-right');
  
  if (!scrollContainer || cards.length === 0) return;

  // Arrow navigation functionality
  if (root.dataset.showNavArrows === 'true') {
  if (leftArrow && rightArrow) {
    // Function to update arrow visibility
    function updateArrowVisibility() {
      const scrollLeft = scrollContainer.scrollLeft;
      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      
      // Show/hide left arrow
      if (scrollLeft > 10) {
        leftArrow.classList.add('sten-show');
      } else {
        leftArrow.classList.remove('sten-show');
      }
      
      // Show/hide right arrow
      if (scrollLeft < maxScroll - 10) {
        rightArrow.classList.add('sten-show');
      } else {
        rightArrow.classList.remove('sten-show');
      }
    }

    // Calculate scroll amount based on screen size
    function getScrollAmount() {
      const cardWrapper = root.querySelector('.sten-subcollection-card-wrapper');
      if (!cardWrapper) return 300;
      
      const cardWidth = cardWrapper.offsetWidth;
      const gap = window.innerWidth >= 768 ? parseInt(root.dataset.gapDesktop, 10) : parseInt(root.dataset.gapMobile, 10);
      
      // On mobile, scroll 2 cards at a time; on desktop, scroll 3
      const cardsToScroll = window.innerWidth >= 768 ? 3 : 2;
      return (cardWidth + gap) * cardsToScroll;
    }

    // Left arrow click with touch support
    leftArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const scrollAmount = getScrollAmount();
      scrollContainer.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    // Right arrow click with touch support
    rightArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const scrollAmount = getScrollAmount();
      scrollContainer.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    // Touch events for better mobile support
    leftArrow.addEventListener('touchend', function(e) {
      e.preventDefault();
      this.click();
    });

    rightArrow.addEventListener('touchend', function(e) {
      e.preventDefault();
      this.click();
    });

    // Update arrow visibility on scroll
    scrollContainer.addEventListener('scroll', updateArrowVisibility);
    
    // Initial arrow visibility check
    updateArrowVisibility();
    
    // Update on window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrowVisibility, 150);
    });

    // Check if scrollable and show/hide arrows accordingly
    function checkScrollable() {
      const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
      if (isScrollable) {
        updateArrowVisibility();
      } else {
        leftArrow.classList.remove('sten-show');
        rightArrow.classList.remove('sten-show');
      }
    }
    
    // Check scrollable on load and resize
    checkScrollable();
    window.addEventListener('resize', checkScrollable);
  }
  }
  
  if (root.dataset.enableKeyboardNavigation === 'true') {
  // Enhanced keyboard navigation
  scrollContainer.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      const direction = e.key === 'ArrowRight' ? 1 : -1;
      const cardWrapper = root.querySelector('.sten-subcollection-card-wrapper');
      const gap = window.innerWidth >= 768 ? parseInt(root.dataset.gapDesktop, 10) : parseInt(root.dataset.gapMobile, 10);
      const cardWidth = cardWrapper ? cardWrapper.offsetWidth + gap : 120;
      const currentScroll = scrollContainer.scrollLeft;
      const newScroll = currentScroll + (cardWidth * direction);
      
      scrollContainer.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }
  });
  
  // Add focus management for better accessibility
  cards.forEach((card, index) => {
    card.addEventListener('focus', function() {
      const cardRect = card.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      
      // Scroll card into view if partially hidden
      if (cardRect.left < containerRect.left || cardRect.right > containerRect.right) {
        card.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    });
  });
  }

  if (root.dataset.enableDragScroll === 'true') {
  // Optional drag scrolling with improved click detection
  (function initDragScroll() {
    // Check if content is scrollable
    const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;
    if (!isScrollable) return;
    
    // Only enable for desktop with mouse
    if ('ontouchstart' in window || window.matchMedia('(pointer: coarse)').matches) return;
    
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let scrollLeft = 0;
    let clickStartTime = 0;
    let hasMoved = false;
    
    const sensitivity = 1;
    const MOVEMENT_THRESHOLD = 10; // pixels
    const TIME_THRESHOLD = 300; // milliseconds
    
    function handleMouseDown(e) {
      // Only handle left mouse button
      if (e.button !== 0) return;
      
      // Check if clicking on a link or button
      const isInteractive = e.target.closest('a, button');
      if (!isInteractive) {
        isDragging = true;
        clickStartTime = Date.now();
        startX = e.pageX;
        startY = e.pageY;
        scrollLeft = scrollContainer.scrollLeft;
        hasMoved = false;
        
        scrollContainer.style.cursor = 'grabbing';
        scrollContainer.style.userSelect = 'none';
        
        e.preventDefault();
      }
    }
    
    function handleMouseMove(e) {
      if (!isDragging) return;
      
      e.preventDefault();
      
      const deltaX = Math.abs(e.pageX - startX);
      const deltaY = Math.abs(e.pageY - startY);
      
      // Check if mouse has moved enough to be considered a drag
      if (deltaX > MOVEMENT_THRESHOLD || deltaY > MOVEMENT_THRESHOLD) {
        hasMoved = true;
        const x = e.pageX;
        const walk = (x - startX) * sensitivity;
        scrollContainer.scrollLeft = scrollLeft - walk;
      }
    }
    
    function handleMouseUp(e) {
      if (!isDragging) return;
      
      isDragging = false;
      scrollContainer.style.cursor = '';
      scrollContainer.style.userSelect = '';
      
      const clickDuration = Date.now() - clickStartTime;
      
      // If it was a quick click without movement, allow the click to propagate
      if (!hasMoved && clickDuration < TIME_THRESHOLD) {
        // Find the card under the cursor and click it
        const element = document.elementFromPoint(e.clientX, e.clientY);
        const card = element?.closest('.sten-subcollection-card');
        if (card) {
          card.click();
        }
      }
    }
    
    function handleMouseLeave() {
      if (isDragging) {
        isDragging = false;
        scrollContainer.style.cursor = '';
        scrollContainer.style.userSelect = '';
      }
    }
    
    // Add event listeners
    scrollContainer.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);
    
    // Set initial cursor
    scrollContainer.style.cursor = 'grab';
  })();
  }
  
  // Custom always-visible, draggable scrollbar.
  // Native scrollbars auto-hide (and won't hold a brand color across browsers),
  // so we draw our own thumb/track and keep it in sync with scrollLeft.
  (function initCustomScrollbar() {
    const bar = root.querySelector('.sten-custom-scrollbar');
    if (!bar) return;
    const track = bar.querySelector('.sten-custom-scrollbar-track');
    const thumb = bar.querySelector('.sten-custom-scrollbar-thumb');
    if (!track || !thumb) return;

    function maxScroll() {
      return scrollContainer.scrollWidth - scrollContainer.clientWidth;
    }

    // Reflect the scroll position onto the thumb (size + position).
    function syncThumb() {
      const scrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      bar.classList.toggle('sten-is-scrollable', scrollable);
      if (!scrollable) return;

      const trackWidth = track.clientWidth;
      const ratio = scrollContainer.clientWidth / scrollContainer.scrollWidth;
      const thumbWidth = Math.max(28, Math.round(trackWidth * ratio));
      const travel = trackWidth - thumbWidth;
      const progress = maxScroll() > 0 ? scrollContainer.scrollLeft / maxScroll() : 0;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + Math.round(progress * travel) + 'px)';
    }

    // Map a pointer position on the track to a scrollLeft (used by drag + track click).
    function scrollToThumbLeft(thumbLeft) {
      const trackWidth = track.clientWidth;
      const thumbWidth = thumb.offsetWidth;
      const travel = trackWidth - thumbWidth;
      const progress = travel > 0 ? Math.min(Math.max(thumbLeft, 0), travel) / travel : 0;
      scrollContainer.scrollLeft = progress * maxScroll();
    }

    let dragging = false;
    let dragStartX = 0;
    let dragStartLeft = 0;

    function onPointerDown(e) {
      dragging = true;
      dragStartX = e.clientX;
      dragStartLeft = thumb.getBoundingClientRect().left - track.getBoundingClientRect().left;
      thumb.classList.add('sten-dragging');
      if (thumb.setPointerCapture && e.pointerId != null) {
        try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
      e.stopPropagation();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      scrollToThumbLeft(dragStartLeft + (e.clientX - dragStartX));
      e.preventDefault();
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      thumb.classList.remove('sten-dragging');
    }

    thumb.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);

    // Click on the empty track jumps the thumb (and scroll) to that spot.
    track.addEventListener('pointerdown', function(e) {
      if (e.target === thumb) return;
      const rect = track.getBoundingClientRect();
      scrollToThumbLeft(e.clientX - rect.left - thumb.offsetWidth / 2);
    });

    scrollContainer.addEventListener('scroll', syncThumb, { passive: true });
    window.addEventListener('resize', function() { requestAnimationFrame(syncThumb); });
    if (window.ResizeObserver) {
      new ResizeObserver(function() { syncThumb(); }).observe(scrollContainer);
    }

    syncThumb();
  })();

  // Analytics tracking for collection clicks
  cards.forEach((card, index) => {
    card.addEventListener('click', function(e) {
      // Current-collection card has no href and goes nowhere — skip tracking.
      if (!this.href) return;
      const collectionName = this.getAttribute('aria-label');
      const discountOffer = this.querySelector('.sten-discount-offer');
      const saleEndsToday = this.querySelector('.sten-sale-banner');
      
      // Google Analytics 4 tracking with promotion data
      if (typeof gtag !== 'undefined') {
        gtag('event', 'select_promotion', {
          'promotion_id': this.href.split('/').pop(),
          'promotion_name': collectionName,
          'creative_name': discountOffer ? discountOffer.textContent : '',
          'creative_slot': saleEndsToday ? 'sale_banner' : 'discount_overlay',
          'location_id': 'sub_collections'
        });
        
        gtag('event', 'select_item', {
          'item_list_id': 'sub_collections',
          'item_list_name': 'Sub Collections',
          'items': [{
            'item_id': this.href.split('/').pop(),
            'item_name': collectionName,
            'item_category': 'Collection',
            'index': index,
            'promotion': discountOffer ? discountOffer.textContent : ''
          }]
        });
      }
    });
  });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="sten-sub-collections-v2"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
